import styled from "styled-components";

export const Garantia = styled.div`
  background-color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    #children-div-text {
      display: flex;
      flex-direction: column;
      padding: 43px;
      gap: 40px;
      margin: 0 auto;
    }

    #title-div {
      display: flex;
      flex-direction: column;
      gap: 10px;

      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 122%;
        text-transform: uppercase;
        color: var(--orange);
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
      }
    }

    #paragraph {
      font-weight: 400;
      font-size: 14px;
      line-height: 160%;
      color: var(--paragraph);

      #span-orange {
        color: var(--orange);
        font-weight: 700;
      }
    }

    #children-div-img {
      width: 100%;
      display: flex;
      flex-direction: column;
        align-items: center;

      figure {
        width: 90%;
        margin-right: 30px;

        img {
          width: 100%;
        }
      }

      h3 {
        display: flex;
        align-items: center;
        margin: 15px;
        color: var(--orange);
        border-bottom: 2px solid var(--orange);
      }
    }
  }

  @media (min-width: 601px) {
    background-image: url(${(props) => props.backInvestiment});
    background-size: 110vw;
    height: 468px;

    #pather-div {
      flex-direction: row;

      #children-div-text {
        width: 50%;

        #title-div {
          span {
            font-size: 16px;
          }

          h1 {
            font-size: 48px;
          }
        }

        #paragraph {
          font-size: 16px;
        }
      }

      #children-div-img {
        width: 50%;
        display: flex;
        justify-content: flex-end;

        figure {
          filter: drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.25));
          width: 65%;
          margin-right: 16%;

          img {
            width: 100%;
          }
        }

        h3 {
          display: none;
        }
      }
    }
  }
`;
